import { Directive, ElementRef, HostListener, Input, output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ADPResourceService } from 'digital-core';

@Directive({
    selector: '[pghAlphaNumericOnly]',
    standalone: true
})
export class AlphaNumericOnlyDirective {
  readonly valueChange = output();
  constructor(private _el: ElementRef,
    private resourceService: ADPResourceService,
    private ngControl: NgControl
  ) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    let contractRegexPatttern = this.resourceService.getPortalSetting('Global_CTC_ContractRegexPatttern').Value;
    contractRegexPatttern = `[^${contractRegexPatttern}]*`;
    const regExp = new RegExp(contractRegexPatttern, 'g');
    const newValue = initalValue.replace(regExp, '');
    this._el.nativeElement.value = newValue;
    this.valueChange.emit(newValue);
    this.ngControl.control.setValue(newValue);
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
